var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-product-quick-edit-price", {
    attrs: { title: _vm.title, value: _vm.amount, handler: _vm.save },
    on: {
      close: function ($event) {
        return _vm.close()
      },
      refresh: function ($event) {
        return _vm.refresh()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }